"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _button = _interopRequireDefault(require("../button/button.js"));
var _checkbox = _interopRequireDefault(require("../checkbox/checkbox.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function CreateAccountForm(props) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    terms = _useState2[0],
    setTerms = _useState2[1];
  var handleTerms = function handleTerms(e) {
    console.log('handleTerms', terms);
    setTerms(!terms);
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    props.form.validateFields(function (err, values) {
      if (!err) props.signUp(values);
    });
  };
  var getFieldDecorator = props.form.getFieldDecorator;
  return /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    onSubmit: handleSubmit,
    className: "login-form"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Sign up"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "auth-switcher"
  }, "or ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    onClick: function onClick(e) {
      props.formSwitcher(e, "SignIn");
    }
  }, "sign in to your account")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-columns"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "First name"), getFieldDecorator("firstName", {
    rules: [{
      required: true,
      message: "Enter your First name."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    placeholder: "Enter First name"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Last name"), getFieldDecorator("lastName", {
    rules: [{
      required: true,
      message: "Enter your last name."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    placeholder: "Enter Last name"
  })))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Email"), getFieldDecorator("email", {
    rules: [{
      required: true,
      message: "Enter a valid email address."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    placeholder: "Enter email"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Password"), getFieldDecorator("password", {
    rules: [{
      required: true,
      message: "Enter Password."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    type: "password",
    placeholder: "Enter password"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    className: "labelContainer",
    label: /*#__PURE__*/_react["default"].createElement("div", null, "I accept the", " ", /*#__PURE__*/_react["default"].createElement("a", {
      href: "",
      className: "turing-link blackLink"
    }, /*#__PURE__*/_react["default"].createElement("b", null, "terms and conditions"))),
    onChange: function onChange(e) {
      return handleTerms(e);
    },
    checked: terms
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Sign up",
    primary: true,
    htmlType: "submit",
    className: "login-form-button",
    wide: true
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "or"), /*#__PURE__*/_react["default"].createElement("hr", null))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: "socialAuth",
    label: "Sign in with Google",
    google: true,
    wide: true
  }), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    label: "Sign in with Facebook",
    className: "socialAuth",
    facebook: true,
    wide: true
  })));
}
var _default = exports["default"] = CreateAccountForm;